import mitt from 'mitt';

type Events = {
  sampleIdChange: string;
  newResults: string;
  update: string;
  
  // Puedes agregar más eventos si necesitas
  // e.g. 'dataUpdated': any;
};

const eventBus = mitt<Events>();

export default eventBus;